import React from 'react';
import ServicePageTemplate from '../components/ServicePageTemplate';
import { Target } from 'lucide-react';

const BinaryOptionsPage = () => (
  <ServicePageTemplate
    translationPrefix="binaryPage"
    icon={Target}
    color="from-purple-500 to-purple-600"
    accentColor="bg-purple-50 border border-purple-200"
  />
);

export default BinaryOptionsPage;
